import { IReservationTypeDetails } from 'modules/accommodations/features/reservations/models';
import API from 'services/api';

export const getReservationType = (id: string, type: string): Promise<IReservationTypeDetails> =>
  API.get(`/api/accommodation/reservation/${id}/type/${type}`).then(response => response?.data);
